import { Record } from 'immutable';
import EmptyList from './EmptyList';
import Catalog from './Catalog';

const AnswerRecord = Record({
  ugc_id: '',
  subject_id: null,
  ugctype: '',
  ugc_archetype: '',
  created_date: '',
  updated_date: '',
  author: '',
  location: '',
  answer: '',
  email: '',
  merchant_user_id: '',
  answerer_type: '',
  source: '',
  ip_address: '',
  device_id: '',
  locale: '',
  published: null,
  ugc_related_content: EmptyList,
  catalog: Catalog.Empty,
  expert: false,
});

export default class Answer extends AnswerRecord {
  static createWithData(data) {
    return new Answer({
      ...data,
      answer: data.answer || data.text || '',
      ugc_archetype: data.ugc_archetype || 'Answer',
    });
  }

  getQuestion() {
    return this.ugc_related_content.find(
      ugc => ugc.ugc_archetype === 'Question'
    );
  }

  getMedia() {
    return this.ugc_related_content
      .filter(ugc => ugc.ugctype === 'Image' || ugc.ugctype === 'Video')
      .filter(ugc => ugc.parent_ugc_id === this.ugc_id);
  }
}



// WEBPACK FOOTER //
// ./src/models/Answer.js